export const DEFAULT_EXTENSIONS = '.pdf'
export const DEFAULT_MAX_SIZE = 5 // Em MB
